import {tap} from 'rxjs';
import {afterNextRender, Component, OnInit, PLATFORM_ID, ChangeDetectionStrategy, ChangeDetectorRef, inject, DestroyRef} from '@angular/core';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {NavigationEnd, Router, RouterLink, RouterLinkActive} from "@angular/router";
import {AuthService} from "../../../services/auth.service";
import {ThemeService} from "../../../services/theme.service";
import {SettingsService} from "../../../services/settings.service";
import {UserType} from "../../../enums/users/UserType";
import {environment} from "../../../../environments/environment.development";
import {rNames} from "../../../r.names";
import {RETURN_URL_PARAM, safeReturnUrl} from "../../../guards/auth-redirect";
import { isPlatformBrowser } from '@angular/common';
import {ContainerComponent} from '../../../../components/container/container.component';
import {CryptoTickerComponent} from '../../../../currencies/views/crypto-ticker/crypto-ticker.component';
import {AdminPendingBarComponent} from '../../../components/admin-pending-bar/admin-pending-bar.component';
import {HlmButtonImports} from '@spartan-ng/helm/button';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [ContainerComponent, RouterLink, RouterLinkActive, CryptoTickerComponent, AdminPendingBarComponent, HlmButtonImports]
})
export class HeaderComponent implements OnInit {
  authService = inject(AuthService);
  router = inject(Router);
  protected theme = inject(ThemeService);
  settings = inject(SettingsService);
  private platformId = inject(PLATFORM_ID);

  private readonly cdr = inject(ChangeDetectorRef);
  private destroyRef = inject(DestroyRef);


  r = rNames;

  /**
   * Query for the header «Вход»/«Регистрация» links: on the login/register page keep the safe ?returnUrl=,
   * so switching between them doesn't lose the page a guard sent the visitor away from (#1055).
   */
  authQuery(): Record<string, string> | null {
    const tree = this.router.parseUrl(this.router.url);
    const path = '/' + (tree.root.children['primary']?.segments.map(s => s.path).join('/') ?? '');
    if (path !== '/' + rNames.login && path !== '/' + rNames.register) {
      return null;
    }
    const returnUrl = safeReturnUrl(tree.queryParamMap.get(RETURN_URL_PARAM));
    return returnUrl ? {[RETURN_URL_PARAM]: returnUrl} : null;
  }
  UserType = UserType;
  protected readonly environment = environment;
  isWarning: boolean = false;

  /**
   * auth-разметку показываем только на клиенте после гидратации:
   * SSR не знает localStorage и всегда рендерит «гостя» — если клиент сразу
   * дорисует «Выйти/Админ», при несовпадении SSR-DOM получаем оба блока разом.
   */
  authReady = false;

  constructor() {

    afterNextRender(() => {
      // гидратация завершена — можно показывать авторизационные кнопки
      this.authReady = true;

      let warn = localStorage.getItem('warn');
      if (warn) {
        if (warn == 'false') {
          this.isWarning = false;
        } else {
          this.isWarning = true;
          localStorage.removeItem('warn');
        }
      }
    })
  }

  ngOnInit(): void {

    // sync с data-theme, который ранний скрипт в index.html выставил до загрузки
    this.theme.init();

    // флаги видимых разделов (Курсы и т.п.) — для ссылок меню и SSR
    this.settings.load().pipe(takeUntilDestroyed(this.destroyRef), tap({next: () => this.cdr.markForCheck(), error: () => this.cdr.markForCheck(), complete: () => this.cdr.markForCheck()})).subscribe();

    this.router.events.pipe(takeUntilDestroyed(this.destroyRef), tap({next: () => this.cdr.markForCheck(), error: () => this.cdr.markForCheck(), complete: () => this.cdr.markForCheck()})).subscribe({
      next: value => {
        if (value instanceof NavigationEnd) {
          if (!value.url.match(rNames.login)
            && !value.url.match(rNames.register)) {
            this.authService.returnUrl = value.url;
          }
        }

      }
    })

  }


  hideWarning() {
    this.isWarning = false;
    if (isPlatformBrowser(this.platformId)) {
      localStorage.setItem('warn', String(false));
    }
  }

  showWarning() {
    this.isWarning = true;
    if (isPlatformBrowser(this.platformId)) {
      localStorage.removeItem('warn');
    }
  }
}
